import { Component, Input } from '@angular/core';
import { subMinutes } from 'date-fns';
import { Labels } from 'src/app/app.models';
import { LocationOperatingHours } from 'src/app/models/location.model';
import { MgoDateAdapter } from 'src/app/shared/utils/mg-date-adapter';
import { StringUtils } from 'src/app/shared/utils/string-utils';

@Component({
  selector: 'app-location-closing-hour',
  templateUrl: './location-closing-hour.component.html',
  styleUrls: ['./location-closing-hour.component.scss'],
})
export class LocationClosingHourComponent {
  @Input() businessHours!: LocationOperatingHours;
  locationLabels: any;

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.locationLabels = labels.stellar.location;
  }
  public get labels() {
    return this._labels;
  }
  public weekDays: string[] = [
    'sunHours',
    'monHours',
    'tueHours',
    'wedHours',
    'thuHours',
    'friHours',
    'satHours',
  ];
  public dayNum: number = new Date().getDay();

  constructor(private dateUtil: MgoDateAdapter) {}

  private getBusinessHours(businessHours: LocationOperatingHours) {
    const weekDay = this.weekDays[this.dayNum];
    const [openingTime, closingTime] =
      businessHours &&
      businessHours[weekDay]
        .split('-')
        .map((hour: string) => hour.trim())
        .map((hour: string) => this.dateUtil.convertHour(hour));

    return { openingTime, closingTime, currTime: new Date() };
  }

  /* get css class names for closing time */
  public getClosingHourClass(businessHours: LocationOperatingHours): string {
    const { openingTime, closingTime, currTime } =
      this.getBusinessHours(businessHours);
    if (currTime > openingTime && closingTime > currTime) {
      return 'text-closinghour green-color';
    } else if (
      currTime > openingTime &&
      closingTime > currTime &&
      closingTime.getHours() - currTime.getHours() <= 1
    ) {
      return 'text-closinghour orange-color';
    } else if (currTime > closingTime || currTime < openingTime) {
      return 'text-closinghour error-color';
    }
    return 'text-closinghour';
  }

  /* get text for closing time */
  public getClosingHour(businessHours: LocationOperatingHours): any {
    const { currTime, openingTime, closingTime } =
      this.getBusinessHours(businessHours);
    if (currTime > openingTime && closingTime > currTime) {
      const time = subMinutes(closingTime, 1);
      const options: any = {
        hour: 'numeric',
        hour12: true,
        minute: 'numeric',
      };
      return StringUtils.capitalizeWord(
        this.locationLabels?.openUntil +
          ` ${time.toLocaleString(undefined, options)}`
      );
    } else if (currTime > closingTime) {
      const nextDayNum = this.dayNum < 6 ? this.dayNum + 1 : 0;
      const nextWeekDay = this.weekDays[nextDayNum];
      const nextOpeningTime = businessHours[nextWeekDay].split('-')[0].trim();
      return StringUtils.capitalizeWord(
        this.locationLabels.closedOpenTxt + ` ${nextOpeningTime}`
      );
    } else if (currTime < openingTime) {
      return StringUtils.capitalizeWord(
        this.locationLabels.closedOpenTxt + ` ${openingTime}`
      );
    }
  }

  getFilterClosingHours(str: string) {
    return str.split(" ").filter((word, index) => ![4, 5, 6].includes(index) && index < 8).join(" ")
  }
}
